import { useState } from 'react';

import { Button } from "react-bootstrap";

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ApplicationsDashboardCards from '../../components/admin/applications/ApplicationsDashboardCards.jsx';
import ApplicationModal from '../../components/admin/applications/ApplicationModal.jsx';
import ApplicationsTable from '../../components/admin/applications/ApplicationsTable.jsx';
import { licenses as applications } from "./data.js";

function ApplicationsPage(props) {
    const [showModal, setShowModal] = useState(false)

    return <>
        <div className="container">
            <div className="d-flex justify-content-between mb-4">

                <h3 style={{ color: '#fff' }}>Gerenciamento de Aplicativos</h3>

                <Button onClick={() => setShowModal(true)}>
                    <FontAwesomeIcon icon={faPlus} /> Nova Aplicativo
                </Button>

            </div>
            <ApplicationsDashboardCards />
            <ApplicationsTable applications={applications} />
            <ApplicationModal
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </div>
    </>
}

export default ApplicationsPage;